module.exports = __webpack_public_path__ + "img/settings.9df4bb1.png";